import React, {Component} from 'react';
import OptionsV2 from './OptionsV2';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {fetchCapabilityCallSuccess, fetchCycles, fetchCPTList} from "../actions/OptionsActionsV2";
import Column from "@amzn/meridian/column";
import {GRID_ALLOCATION_ROUTE, STOW_BREAKDOWN_V2_ROUTE, STOW_ROUTES} from "./utils/RouteConstants";
import Navigation, {NavigationRoutes} from "./utils/Navigation";
import {getNodeId, extractRouteCodePrefixesFromParam, isOnlyRouteViewApplicable} from "../Utility";
import {FEATURES, OPTIONS_TAG_REQUIRED, HEADERS} from "../constants";
import {Capability, ViewType} from "../enums";
import HeatMapViewOptionsV2 from "./options/HeatMapViewOptionsV2";
import {getFeaturesFromParent, getNodeCapabilityFromParent} from "../handler/ParentDataHandler";
import {fetchFeatureStatusCallSuccess} from "../actions/ConfigActions";
import {PageHeader} from "./utils/PageHeader";
import FilterOptionsV2 from "./options/FilterOptionsV2";
import {useDeviceLayout} from "./common/context/DeviceLayoutContext";

class HeatMapV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nodeId: getNodeId(),
            routeCodePrefixes: extractRouteCodePrefixesFromParam(props)
        };
    }



    render() {
        const {selectedView, spacingInset_shorthand5} = this.props;
        let routes = this.getRoutesToShow();

        return (
            <Column spacingInset={spacingInset_shorthand5}>
                <PageHeader {...HEADERS.HEATMAP}/>
                {this.renderOptions(selectedView)}
                <Navigation routes={routes} location={this.props.location} history={this.props.history}/>
                <NavigationRoutes routes={routes}/>
            </Column>
        )
    }

    renderOptions(selectedView) {
        return !isOnlyRouteViewApplicable(this.state.nodeId, this.props.capability)
            && <OptionsV2 options={this.getApplicableOptions(selectedView)} optionsTagsRequired={this.getApplicableOptionTags(selectedView)}/>
    }

    getRoutesToShow() {
        var routes = STOW_ROUTES;
        if(this.props.featureStatus && this.props.featureStatus[FEATURES.STOW_BREAKDOWN_V2]) {
            routes = routes.concat([STOW_BREAKDOWN_V2_ROUTE]);
        }
        if(this.props.featureStatus && this.props.featureStatus[FEATURES.GRID_ALLOCATION_VIEW_ENABLED]) {
            routes = routes.concat([GRID_ALLOCATION_ROUTE]);
        }
        return routes;
    }

    getApplicableOptions(selectedView) {
        if (ViewType.ROUTE_VIEW === selectedView || ViewType.SIDELINE_VIEW === selectedView || Capability.AR_NEXT_GEN === this.props.capability)
            return [{component: <HeatMapViewOptionsV2/>, name: "HeatMapViewOptions"}]
        else
            return [{component: <HeatMapViewOptionsV2/>, name: "HeatMapViewOptions"}, {component: <FilterOptionsV2/>, name: "FilterOptionsV2"}]
    }

    getApplicableOptionTags(selectedView) {
        if (ViewType.ROUTE_VIEW === selectedView || ViewType.SIDELINE_VIEW === selectedView || Capability.AR_NEXT_GEN === this.props.capability)
            return []

        return OPTIONS_TAG_REQUIRED
    }

    componentDidMount() {
        getFeaturesFromParent([FEATURES.CART_VISIBILITY, FEATURES.ADTA_VISIBILITY, FEATURES.SIDELINE_STOW_VISIBILITY, FEATURES.SIDELINE_STOW_V2, FEATURES.REINDUCT_DATE_PLUS_ONE_FIX, FEATURES.GRID_ALLOCATION_VIEW_ENABLED, FEATURES.STOW_BREAKDOWN_V2, FEATURES.DOWNLOAD_SORT_PLAN_BUTTON_VISIBILITY]).then(featureStatusResponse => {
            this.props.dispatch(fetchFeatureStatusCallSuccess(featureStatusResponse.data));
        })
        getNodeCapabilityFromParent().then(capabilityResponse => {
            const capability = JSON.parse(capabilityResponse.capability);
            getFeaturesFromParent([FEATURES.IS_CPT_FILTER_ENABLED]).then(featureStatusResponse => {
                this.props.dispatch(fetchFeatureStatusCallSuccess(featureStatusResponse.data))
            })
            if(this.props.featureStatus && this.props.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED] && Capability.AR_NEXT_GEN !== capability){
                this.props.dispatch(fetchCPTList());
            }
            else if (Capability.AR_NEXT_GEN !== capability) {
                this.props.dispatch(fetchCycles());
            }
            this.props.dispatch(fetchCapabilityCallSuccess(capabilityResponse));
        })
    }
}

// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent) {
    return function WrappedComponent(props) {
        const {spacingInset_shorthand5} = useDeviceLayout();
        return <CustomComponent {...props} spacingInset_shorthand5={spacingInset_shorthand5}/>
    }
}

const mapStateToProps = state => ({
    capability: state.optionsReducerV2.capability,
    navigationOptions: state.optionsReducerV2.navigationOptions,
    selectedCycle: state.optionsReducerV2.options.cycle,
    selectedView: state.optionsReducerV2.heatMapView,
    selectedCycleId: state.optionsReducerV2.options.cycleId,
    featureStatus: state.configReducer.featureStatus,
    isInitialView: state.optionsReducerV2.isInitialView

});
export default withRouter(connect(mapStateToProps)(classToFunctionAdapter(HeatMapV2)));


// WEBPACK FOOTER //
// ./src/components/HeatMapV2.js